import { useEffect } from "react";
import { appIdentity } from "../../utils/appIdentity";
import { RoutesOption } from "../../routes";
import { useSearchQuery } from "../../search/useSearchQuery";

export const useHtmlTitle = () => {
  const query = useSearchQuery();
  useEffect(() => {
    switch (window.location.pathname) {
      case RoutesOption.Home: {
        document.title = query.isAll ? appIdentity.name : `Search Results | ${appIdentity.name}`;
        break;
      }
      default:
        document.title = appIdentity.name;
    }
    return () => {
      document.title = appIdentity.name;
    };
  }, [query]);
};
